'use client';

import Link from 'next/link';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  variant?: 'light' | 'dark';
}

export function Breadcrumbs({ items, variant = 'light' }: BreadcrumbsProps) {
  const styles = {
    light: {
      separator: 'text-gray-400',
      link: 'text-gray-600 hover:text-[var(--ra-green)]',
      current: 'text-gray-900 font-medium',
    },
    dark: {
      separator: 'text-gray-500',
      link: 'text-gray-400 hover:text-white',
      current: 'text-white font-medium',
    },
  };

  const s = styles[variant];

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center flex-wrap gap-1.5 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <svg
                className={`w-4 h-4 ${s.separator}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            )}
            {item.href ? (
              <Link
                href={item.href}
                className={`${s.link} transition-colors`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={s.current}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
